'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _dropZoneUtils = require('./dropZoneUtils');

var _Label = require('./Label');

var _Label2 = _interopRequireDefault(_Label);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function FileSize(_ref) {
  var contentSize = _ref.contentSize;

  var _humanFileSize = (0, _dropZoneUtils.humanFileSize)(contentSize),
      unitText = _humanFileSize.unitText,
      value = _humanFileSize.value;

  return _react2.default.createElement(
    'div',
    { className: 'dz-size' },
    _react2.default.createElement(_Label2.default, { text: 'Size:' }),
    _react2.default.createElement(
      'span',
      { className: 'dz-size-value' },
      value
    ),
    _react2.default.createElement(
      'span',
      { className: 'dz-size-unit' },
      unitText
    )
  );
}
FileSize.propTypes = {
  contentSize: _propTypes2.default.number.isRequired
};
exports.default = FileSize;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/cape-mixer/lib/FileUpload/FileSize.js
// module id = 688
// module chunks = 0